import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const actions = [
  {
    icon: '🗂️',
    label: 'Categories',
    gradient: 'qa-amber',
    desc: '50+ types',
    path: '/categories',
  },
  {
    icon: '🔥',
    label: 'Deals',
    gradient: 'qa-rose',
    desc: 'Up to 40% off',
    badge: 'HOT',
    path: '/browse-deals',
  },
  {
    icon: '🆕',
    label: 'New Arrivals',
    gradient: 'qa-emerald',
    desc: 'Just added',
    path: '/collections?tab=arrivals',
  },
  {
    icon: '📈',
    label: 'Trending',
    gradient: 'qa-violet',
    desc: 'This week',
    path: '/collections?tab=trending',
  },
  {
    icon: '✨',
    label: 'AI Recommended',
    gradient: 'qa-ai',
    desc: 'Just for you',
    badge: 'AI',
    path: '/ai-recommendations',
  },
  {
    icon: '📐',
    label: 'Body Measure',
    gradient: 'qa-teal',
    desc: 'Get your size',
    badge: 'NEW',
    path: '/body-measurement',
  },
];

const containerVariants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};

const QuickActions = () => {
  const navigate = useNavigate();
  return (
  <section className="qa-section">
    <motion.div
      className="qa-grid"
      variants={containerVariants}
      initial="hidden"
      animate="show"
    >
      {actions.map((action) => (
        <motion.button
          key={action.label}
          variants={itemVariants}
          whileHover={{ y: -4, scale: 1.04 }}
          whileTap={{ scale: 0.96 }}
          className={`qa-card ${action.gradient}`}
          style={action.path ? { cursor: 'pointer' } : {}}
          onClick={() => action.path && navigate(action.path)}
        >
          {action.badge && (
            <span className="qa-badge">{action.badge}</span>
          )}
          <span className="qa-icon">{action.icon}</span>
          <span className="qa-label">{action.label}</span>
          <span className="qa-desc">{action.desc}</span>
        </motion.button>
      ))}
    </motion.div>
  </section>
  );
};

export default QuickActions;
